import { elementController } from '@public-pages/runtime-core';

elementController('benefits', ({ queryAll }) => {
  let activeCard: HTMLElement | null = null;
  const cardsList = queryAll('.collapse-card__header');

  cardsList.forEach((card, index) => card.addEventListener('click', () => handleCardClick(index)));

  function closeCard(card: HTMLElement) {
    const arrow = card.querySelector('.collapse-card__arrow') as HTMLElement;
    const content = card.querySelector('.collapse-card__content') as HTMLElement;

    arrow.classList.remove('collapse-card__arrow--expanded');
    content.dataset.open = 'false';
  }

  function handleCardClick(index: number) {
    const clickedCard = cardsList[index] as HTMLElement;
    const clickedCardParent = clickedCard.parentElement as HTMLElement;

    const arrow = clickedCard.querySelector('.collapse-card__arrow') as HTMLElement;
    const content = clickedCardParent.querySelector('.collapse-card__content') as HTMLElement;

    arrow.classList.add('collapse-card__arrow--expanded');
    content.dataset.open = 'true';


    if (activeCard && activeCard !== clickedCardParent) {
      closeCard(activeCard);
    }

    if (activeCard === clickedCardParent) {
      closeCard(activeCard);
      activeCard = null;
    } else {
      activeCard = clickedCardParent;
    }
  }
});
